import { MarketplaceItemMapping } from './marketplace-item-mapping.model';

export class MarketplaceItemMappingAttribute extends MarketplaceItemMapping {
  public AttributeValues: number[];
  public UnlimitedStock: boolean;
}
